import { cn } from '@/lib/cn';
import { getInitials } from '@/lib/format';

interface AvatarProps {
  src?: string | null;
  name?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base',
  xl: 'h-24 w-24 text-xl',
} as const;

export function Avatar({ src, name, size = 'md', className }: AvatarProps) {
  const initials = getInitials(name, '?');
  return (
    <div
      className={cn(
        'relative flex shrink-0 items-center justify-center overflow-hidden rounded-full',
        'bg-parchment-dark text-parchment-ink font-medium border border-parchment-border',
        sizeMap[size],
        className,
      )}
      aria-label={name ?? 'User'}
    >
      {src ? (
        <img
          src={src}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          decoding="async"
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}
